import domReady from '@wordpress/dom-ready';

domReady(async () => {
	const toggleSelector = '.js-toggle-component';
	const pricingTableSelector = '.js-pricing-table';

	const toggle = document.querySelectorAll(toggleSelector);

	if (!toggle.length) {
		return;
	}

	const { Toggle } = await import('./toggle');

	toggle.forEach((toggleElement) => {
		if (toggleElement.closest(pricingTableSelector) === null) {
			const toggle = new Toggle(toggleElement);
			toggle.init();

			return;
		}

		toggleElement.addEventListener('PricingTableLoaded', function () {
			const toggle = new Toggle(toggleElement);
			toggle.init();
		});
	});
});
